import { useContext } from 'react';
import { TelegramContext, type TelegramContextValue } from './telegramContext.js';

export function useTelegram(): TelegramContextValue {
  const context = useContext(TelegramContext);
  if (!context) throw new Error('useTelegram must be used within TelegramProvider');
  return context;
}
